import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { getAdminSettingsToolPath } from '../admin-tool-registry/admin-tool.registry';
import {
  AdminStatsSectionNav,
  AdminStatsSectionNavItem,
} from '../admin-stats-section-nav/admin-stats-section-nav';

@Component({
  selector: 'admin-tool-reports',
  imports: [RouterOutlet, AdminStatsSectionNav],
  templateUrl: './reports.html',
  host: { class: 'block h-full w-full min-h-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Reports {
  readonly navItems: AdminStatsSectionNavItem[] = [
    { label: 'Dashboard', route: `${getAdminSettingsToolPath('reports')}/dashboard` },
    { label: 'List', route: `${getAdminSettingsToolPath('reports')}/list` },
  ];
}
